import React from "react";

import TextInput from "veneer/TextInput";

interface StringFieldProps {
  error?: boolean;
  field: {
    displayName?: string;
    name: string;
    value?: string | null;
  };
  handleChange: (value: string) => void;
  helperText?: string | null;
  isRequired: boolean;
  readOnly: boolean;
}

const StringField = ({
  error = false,
  field,
  handleChange,
  helperText,
  isRequired,
  readOnly,
}: StringFieldProps) => (
  <TextInput
    dataTestId={`${field.name}.Input`}
    disabled={readOnly}
    error={error}
    fullWidth
    helperText={helperText ?? undefined}
    label={field.displayName}
    onChange={(value: unknown) =>
      handleChange(typeof value === "string" ? value : "")
    }
    required={isRequired}
    type="text"
    value={field.value ?? ""}
  />
);

export { StringField };
